// extracted by mini-css-extract-plugin
module.exports = {"singleImage":"style_singleImage__FDiRe","desc":"style_desc__88Pnt","sign":"style_sign__3jfPC"};